'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.diffArrays = exports.objectKeysApplyFn = exports.constants = exports.countries = exports.makeStyles = exports.makeFlagIconOptions = exports.makeClassesObject = exports.makeClassnames = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require('./classnames');

Object.defineProperty(exports, 'makeClassnames', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_classnames).default;
  }
});
Object.defineProperty(exports, 'makeClassesObject', {
  enumerable: true,
  get: function get() {
    return _classnames.makeClassesObject;
  }
});

var _options = require('./options');

Object.defineProperty(exports, 'makeFlagIconOptions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_options).default;
  }
});

var _styles = require('./styles');

Object.defineProperty(exports, 'makeStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_styles).default;
  }
});

var _countries2 = require('./countries');

var _countries = _interopRequireWildcard(_countries2);

var _constants2 = require('./constants');

var _constants = _interopRequireWildcard(_constants2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.countries = _countries;
exports.constants = _constants;
var objectKeysApplyFn = exports.objectKeysApplyFn = function objectKeysApplyFn(obj, fn) {
  return Object.keys(obj).reduce(function (rObj, key) {
    return _extends({}, rObj, _defineProperty({}, fn(key), obj[key]));
  }, {});
};

var diffArrays = exports.diffArrays = function diffArrays(arA, arB) {
  var arrays = arA.length > arB.length ? [arA, arB] : [arB, arA];
  return arrays[0].filter(function (newArElem) {
    return !arrays[1].includes(newArElem);
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/functions/index.js
// module id = 228
// module chunks = 0